export function parseCurrency(value: string): number | undefined {
  const normalizedValue = value.trim();

  if (!normalizedValue) {
    return undefined;
  }

  if (normalizedValue.includes(',')) {
    return parseFloat(normalizedValue.replace(/\./g, '').replace(',', '.'));
  }

  return parseFloat(normalizedValue);
}

export function formatCurrencyBRL(value: number) {
  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}
